import {
  LayoutDashboard,
  Phone,
  MessageSquare,
  PhoneForwarded,
  Users,
  Calendar,
  Mail,
  Bot,
  BarChart3,
  Users2,
  Code,
  Plug,
  Settings,
  CreditCard,
} from 'lucide-react'
import type { Feature } from '@/hooks/useFeatureGate'
import type React from 'react'

export type NavRole = 'admin' | 'supervisor' | 'agent'

export interface NavItemDef {
  /** Stable identifier used for pinning preferences. */
  key: string
  name: string
  href: string
  icon: React.ElementType
  roles?: NavRole[]
  gatedBy?: Feature
}

/**
 * Single source of truth for navigable items the user can pin to the mobile
 * bottom nav. Order here determines the default-pinned set (first 4 visible
 * items for the user's role).
 */
export const NAV_REGISTRY: NavItemDef[] = [
  { key: 'dashboard', name: 'Home', href: '/', icon: LayoutDashboard },
  { key: 'calls', name: 'Calls', href: '/calls', icon: Phone, gatedBy: 'ai_inbound_agent' },
  { key: 'leads', name: 'Leads', href: '/leads', icon: Users },
  { key: 'agents', name: 'Agents', href: '/agents', icon: Bot, gatedBy: 'ai_inbound_agent' },
  { key: 'chats', name: 'Chats', href: '/chats', icon: MessageSquare },
  { key: 'follow-up', name: 'Follow-Up', href: '/follow-up-queue', icon: PhoneForwarded, gatedBy: 'auto_callback' },
  { key: 'bookings', name: 'Bookings', href: '/bookings', icon: Calendar },
  { key: 'messages', name: 'Messages', href: '/messages', icon: Mail },
  { key: 'analytics', name: 'Analytics', href: '/analytics', icon: BarChart3, roles: ['admin', 'supervisor'] },
  { key: 'team', name: 'Team', href: '/team', icon: Users2, roles: ['admin'] },
  { key: 'widget', name: 'Widget', href: '/widget', icon: Code, roles: ['admin'] },
  { key: 'integrations', name: 'Integrations', href: '/integrations', icon: Plug, roles: ['admin'], gatedBy: 'crm_integrations' },
  { key: 'billing', name: 'Billing', href: '/settings/billing', icon: CreditCard, roles: ['admin'] },
  { key: 'settings', name: 'Settings', href: '/settings', icon: Settings },
]

export function getNavItem(key: string): NavItemDef | undefined {
  return NAV_REGISTRY.find(i => i.key === key)
}

export function visibleForRole(role: NavRole | undefined): NavItemDef[] {
  return NAV_REGISTRY.filter(i => !i.roles || (role && i.roles.includes(role)))
}
